import { useContext } from 'use-context-selector';
import { ModalsContext } from 'Contexts/ModalsContext';

export default function useModals() {
  return useContext(ModalsContext);
}
